import { DomainSheet } from "@/components/domain";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(hotel-rooms)/hotel-rooms/$id/_sheet")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return <DomainSheet onClose={() => navigate({ to: `/hotel-rooms/${id}` })} />;
}
